import { useParams } from "react-router-dom";

import BudgetPlanningPage from "./BudgetPlanningPage";

export const BudgetPlanningCampaignPage = () => {
  const { year, month, campaignId } = useParams();

  if (!year || !month || !campaignId) return null;

  return <BudgetPlanningPage />;
};

export default BudgetPlanningCampaignPage;
